var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIelts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#EC516E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4603_3902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4626 63.64V97H25.9906V63.64H31.4626ZM44.1189 68.056V77.848H55.6389V82.312H44.1189V92.536H57.0789V97H38.6469V63.592H57.0789V68.056H44.1189ZM69.2908 92.584H80.5708V97H63.8188V63.64H69.2908V92.584ZM106.699 63.64V68.104H97.8189V97H92.3469V68.104H83.4189V63.64H106.699ZM123.233 97.336C120.993 97.336 118.977 96.952 117.185 96.184C115.393 95.384 113.985 94.264 112.961 92.824C111.937 91.384 111.425 89.704 111.425 87.784H117.281C117.409 89.224 117.969 90.408 118.961 91.336C119.985 92.264 121.409 92.728 123.233 92.728C125.121 92.728 126.593 92.28 127.649 91.384C128.705 90.456 129.233 89.272 129.233 87.832C129.233 86.712 128.897 85.8 128.225 85.096C127.585 84.392 126.769 83.848 125.777 83.464C124.817 83.08 123.473 82.664 121.745 82.216C119.569 81.64 117.793 81.064 116.417 80.488C115.073 79.88 113.921 78.952 112.961 77.704C112.001 76.456 111.521 74.792 111.521 72.712C111.521 70.792 112.001 69.112 112.961 67.672C113.921 66.232 115.265 65.128 116.993 64.36C118.721 63.592 120.721 63.208 122.993 63.208C126.225 63.208 128.865 64.024 130.913 65.656C132.993 67.256 134.145 69.464 134.369 72.28H128.321C128.225 71.064 127.649 70.024 126.593 69.16C125.537 68.296 124.145 67.864 122.417 67.864C120.849 67.864 119.569 68.264 118.577 69.064C117.585 69.864 117.089 71.016 117.089 72.52C117.089 73.544 117.393 74.392 118.001 75.064C118.641 75.704 119.441 76.216 120.401 76.6C121.361 76.984 122.673 77.4 124.337 77.848C126.545 78.456 128.337 79.064 129.713 79.672C131.121 80.28 132.305 81.224 133.265 82.504C134.257 83.752 134.753 85.432 134.753 87.544C134.753 89.24 134.289 90.84 133.361 92.344C132.465 93.848 131.137 95.064 129.377 95.992C127.649 96.888 125.601 97.336 123.233 97.336Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4603_3902",
    x: 21.9907,
    y: 63.207,
    width: 116.762,
    height: 43.1289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4603_3902"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4603_3902",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIelts);
export default __webpack_public_path__ + "static/media/IELTS.9c021035f3382ed20965e28b2c415611.svg";
export { ForwardRef as ReactComponent };